import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

/**
 * Composant de message d'aide standardisé
 * Utilise le style défini dans le thème (theme.style.aideMessage)
 * Affiche un message avec un fond orange et une bordure gauche
 */
const AideMessage = ({ message, icon, ...props }) => {
    const theme = useTheme();
    const aideMessageStyle = theme.style?.aideMessage || {};

    return (
        <Box
            sx={{
                ...aideMessageStyle,
                display: 'flex',
                alignItems: 'center',
                gap: 1
            }}
            {...props}
        >
            {icon && <span>{icon}</span>}
            <span>{message}</span>
        </Box>
    );
};

AideMessage.propTypes = {
    message: PropTypes.string.isRequired,
    icon: PropTypes.node,
};

export default AideMessage;
